export type FamilyTabKey = 'today' | 'book' | 'work' | 'progress' | 'class' | 'more'

export const familyInboxRoute = (
  category?: string | null,
  options?: { hasTraining?: boolean },
): FamilyTabKey | null => {
  if (category === 'EDU_ATTENDANCE' || category === 'EDU_CLASSES' || category === 'EDU_TODAY') {
    return 'today'
  }
  if (category === 'EDU_ANNOUNCEMENTS' || category === 'EDU_MESSAGES' || category === 'EDU_FEED' || category === 'EDU_EVENTS') {
    return 'class'
  }
  if (category === 'EDU_HOMEWORK') {
    return 'work'
  }
  if (category === 'EDU_REPORTS' || category === 'EDU_PROGRESS') {
    return 'progress'
  }
  if (category === 'EDU_BOOKINGS') {
    return options?.hasTraining ? 'book' : 'more'
  }
  if (category === 'EDU_LEAVE' || category === 'EDU_FEES') {
    return 'more'
  }
  return null
}
